import * as React from 'react';
import './Button.css';

export interface IButtonProps {
  label?: string;
  labelFA?: string;
  type: string;
  disabled?: boolean;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const ICO_USER = 'ico_user';
export const ICO_PASSWORD = 'ico_password';

declare var Waves: any;

export const BTN_TYPE_LARGE = 'BTN_TYPE_LARGE';
export const BTN_TYPE_CIRCLE = 'BTN_TYPE_CIRCLE';
export const BTN_TYPE_CIRCLE_UP = 'BTN_TYPE_CIRCLE_UP';
export const BTN_TYPE_CIRCLE_UP_UP = 'BTN_TYPE_CIRCLE_UP_UP';

class Button extends React.Component<IButtonProps, object> {

  public componentDidMount() {
    Waves.attach('div.button-large', 'waves-light');
  }

  public render() {
    const { disabled, label, labelFA, onClick, type } = this.props;

    let className: string = '';
    switch (type) {
      case BTN_TYPE_LARGE:
        className = 'button-large';
        break;
      case BTN_TYPE_CIRCLE:
        className = 'button-circle';
        break;
      case BTN_TYPE_CIRCLE_UP:
        className = 'button-circle-up';
        break;
      case BTN_TYPE_CIRCLE_UP_UP:
        className = 'button-circle-up-up';
        break;
    }

    const classFA = `fas fa-${labelFA}`;

    if (disabled !== undefined && disabled) {
      className += ' button-disabled';
    }

    return (
      <div className={className} onClick={onClick}>
        {
          label !== undefined &&
          <span>{label}</span>
        }
        {
          labelFA !== undefined &&
          <i className={classFA} />
        }
      </div >

    );
  }
}

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.tsx